import Detail from './index.vue'
export default [{
    path: '/detail',
    name:'detail',
    component:Detail,
}]